<template>
  <va-card :title="$t('menu.deliveries')">
    <div class="row">
      <div class="flex xs12 md2">
        <va-input
          v-model="searchName"
          :label="$t('forms.inputs.load')"
          removable
        >
        </va-input>
      </div>

       <div class="flex xs2">
        <va-select
          v-model="loadType"
          :options='loadTypes'
          label="Tipo de Carga"
          textBy="name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione o tipo de carga"
        />
      </div>

       <div class="flex md1">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page = 0, searchName)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>
    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      no-pagination
      v-show="!loading"
    >
    <template slot="actions" slot-scope="props">
      <va-button
        small
        inline
        color="success"
        icon="fa fa-table"
        class="ma-0"
        :to="{ name: 'load_deliveries', params: { loadID: props.rowData.id } }"
      >
        {{ $t('menu.deliveries') }}
      </va-button>
    </template>
    </va-data-table>
  </va-card>
</template>

<script>

import LoadAPI from '@/services/LoadAPI'
import moment from 'moment'
import * as spinners from 'epic-spinners'
import { mapState } from "vuex";
import { showError } from '@/global'
import LoadTypeAPI from '@/services/LoadTypeAPI'

export default {
  name: 'modals',
  components: {
    ...spinners,
  },
  data () {
    return {
      data: [],
      loading: true,
      datepicker: {
        today: moment(new Date()).format('DD-MM-YYYY')
      },
      showModal: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      searchName: "",
      loadType: {
        id: '',
        name: ''
      },
      loadTypes: [],
    }
  },

  channels: {
    NeedRefreshLoads: {
      received(data) {
        this.readItems()
      },
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshLoads', company: this.currentUser.company })
    this.getDefaultLoadType()
    this.readItems()
  },

  computed: {
    ...mapState(['currentLocality', 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.loads.id'),
      },
      {
        name: 'locality',
        title: this.$t('tables.loads.locality_name'),
      },
      {
        name: 'trip_number',
        title: this.$t('tables.loads.trip_number'),
      },
      {
        name: 'code',
        title: this.$t('tables.loads.code'),
      },
      {
        name: 'vehicle',
        title: this.$t('tables.loads.vehicle'),
      },
      {
        name: 'weight',
        title: this.$t('tables.loads.weight'),
      },
      {
        name: 'quantity_orders',
        title: this.$t('tables.loads.quantity_orders'),
      },
      {
        name: 'quantity_boxes',
        title: this.$t('tables.loads.quantity_boxes'),
      },
      {
        name: 'status',
        title: this.$t('tables.loads.status'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    searchName: function (newVal) {
      if (!newVal) {
        this.readItems()
      }
    },

    loadType: function (newVal) {
      this.readItems()
    },

    '$store.state.currentLocality': function() {
      this.readItems()
    }
  },
  methods: {
    readItems(searchName) {
      this.loading = true

    LoadTypeAPI.getAllLoadTypes().then(response => {
      this.loadTypes = response.data.load_types
    }).catch(e => {
      showError(e)
    });

      const params = {
        search: this.searchName,
        locality: this.currentLocality.id,
        load_type_id: this.loadType.id
      }

      LoadAPI.getFilteredLoads(params).then(response => {
        this.data = response.data.loads
        this.loading = false
      }).catch(e => {
          this.loading = false
          showError(e)
      });
    },
    moment: function () {
      return moment();
    },
    updateShowModal(boolean) {
      this.showModal = boolean
    },
    getMessage () {
      return "InformaÃ§Ãµes da Carga..."
    },

    getDefaultLoadType () {
      LoadTypeAPI.getDefaultLoadType().then(response => {
        this.loadType = response.data.load_type
      }).catch(e => {
        showError(e)
      });
    },
  },
}
</script>

<style lang="scss">
</style>
